import {
	type MarketClassification,
	type SportsData,
	type SubeventTeamData,
} from '~/components/BettingInsights/types';

import {
	Avatar as CxyAvatar,
	AvatarImage,
	PersonAvatar,
	TeamAvatars,
} from './cxy';

export type AvatarProps = {
	betName: string;
	homeOrAway?: 'home' | 'away';
	marketClassification?: MarketClassification;
	marketPropType: string;
	sportsData?: SportsData;
	teamData?: SubeventTeamData;
};

export const Avatar = ({
	betName,
	homeOrAway,
	marketClassification,
	marketPropType,
	sportsData,
	teamData,
}: AvatarProps) => {
	switch (true) {
		case homeOrAway !== undefined:
			const team = homeOrAway
				? teamData?.[homeOrAway]
				: teamData?.[betName === teamData.home?.name ? 'home' : 'away'];

			return (
				<CxyAvatar size="small">
					<AvatarImage alt={`${team?.name} team logo`} src={team?.badgeUrl} />
				</CxyAvatar>
			);
		case sportsData?.participant?.type === 'PLAYER':
			if (
				!sportsData.participant.imageUrl &&
				sportsData.participant.team?.badgeUrl
			) {
				return (
					<CxyAvatar size="medium">
						<AvatarImage
							alt={`${sportsData.participant.team.name} team logo`}
							src={sportsData.participant.team.badgeUrl}
						/>
					</CxyAvatar>
				);
			}
			return (
				<PersonAvatar
					player={{
						name: sportsData.participant.name,
						image: sportsData.participant.imageUrl || '',
					}}
				/>
			);
		case sportsData?.participant?.type === 'TEAM':
			return (
				<CxyAvatar size="medium">
					<AvatarImage
						alt={`${sportsData.participant.name} team logo`}
						src={sportsData.participant.badgeUrl || ''}
					/>
				</CxyAvatar>
			);
		case marketClassification?.includes('PLAYER') ||
			marketPropType.includes('Player'):
			return (
				<PersonAvatar
					player={{
						name: betName,
						image: '',
					}}
				/>
			);
	}

	return (
		<TeamAvatars
			awayTeam={{
				logo: teamData?.away?.badgeUrl || '',
				name: teamData?.away?.name || '',
			}}
			homeTeam={{
				logo: teamData?.home?.badgeUrl || '',
				name: teamData?.home?.name || '',
			}}
			size="xsmall"
		/>
	);
};
